module.exports = __webpack_public_path__ + "static/media/FrescoBanner.268d5396.png";